import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-fill flex-column align-items-center pt-5"
}
const _hoisted_3 = {
  key: 1,
  id: "resume-container"
}
const _hoisted_4 = { class: "d-flex mb-4 mt-2 align-items-center justify-content-between" }
const _hoisted_5 = { class: "d-flex w-100 justify-content-between align-items-center" }
const _hoisted_6 = { class: "m-0 w-100" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mb-0 mt-1 text-secondary" }
const _hoisted_9 = {
  key: 1,
  class: "mb-0 mt-1 text-secondary"
}
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "m-0" }
const _hoisted_12 = { class: "m-0" }
const _hoisted_13 = { style: {"opacity":"0.6"} }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_ticket_option = _resolveComponent("new-ticket-option")!
  const _component_modify_ticket_option = _resolveComponent("modify-ticket-option")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.ticket_options.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "opacity-50 text-center mt-5" }, [
            _createElementVNode("i", { class: "fas fa-ticket-alt ticket-icon" }),
            _createElementVNode("h5", null, "Opciones de tickets")
          ], -1)),
          _createVNode(_component_new_ticket_option, {
            options: _ctx.ticket_options,
            event: _ctx.currentEvent
          }, null, 8, ["options", "event"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ticket_options.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("h6", { class: "m-0" }, "Opciones de tickets", -1)),
            _createVNode(_component_new_ticket_option, {
              options: _ctx.ticket_options,
              event: _ctx.currentEvent
            }, null, 8, ["options", "event"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticket_options, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex flex-column align-items-center justify-content-between border-top px-2 py-3",
              key: option.id
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("h6", _hoisted_6, _toDisplayString(option.name), 1),
                  (option.pack)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                        _createElementVNode("small", null, [
                          _createElementVNode("strong", null, _toDisplayString(option.pack.quantity), 1),
                          _cache[2] || (_cache[2] = _createTextVNode(" boletos tipo ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(option.pack?.option?.name), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createTextVNode(" Inician: ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.sales_starts(option)), 1)
                  ]),
                  (option.ticket_sales_ends?.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                        _cache[4] || (_cache[4] = _createTextVNode(" Finalizan: ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.sales_ends(option)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.format_currency(option.price, option.total)) + " " + _toDisplayString(_ctx.event.currency), 1),
                    _createElementVNode("p", _hoisted_12, [
                      _createElementVNode("small", _hoisted_13, _toDisplayString(option.available_quantity) + " disponibles ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_modify_ticket_option, {
                      option: option,
                      options: _ctx.ticket_options,
                      event: _ctx.event,
                      paymentOptions: _ctx.currentEvent?.payment_options ?? []
                    }, null, 8, ["option", "options", "event", "paymentOptions"]),
                    _createElementVNode("button", {
                      class: "btn btn-primary ms-2",
                      onClick: () => _ctx.removeTicketOption(option)
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                    ]))], 8, _hoisted_15)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}